"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @function parseIntElseNull
 * @param  {string} value The value to parse. If the string argument is not a string, then it is converted
 * to a string (using the ToString abstract operation). Leading whitespace in the string argument is ignored.
 * @return {(null|number)} parsed integer, or null if we could not parse it
 */
var parseIntElseNull = function parseIntElseNull(value) {
  var intConversion = parseInt(value, 10);
  return Number.isInteger(intConversion) ? intConversion : null;
};

var _default = parseIntElseNull;
exports["default"] = _default;